import { combineReducers } from 'redux';

import AuthReducer from './Auth';
import InitialReducer from './Initial';
import ModalReducer from '../slices/modalSlice';
import MenuReducer from './menu';
import SnackbarReducer from './snackbar';
import UserReducer from './User';
import ManagerReducer from './Manager';
import OrgReducer from './Org';
import PropertiesReducer from './Properties';
import InvitesReducer from './Invites';
import AccessLogReducer from './AccessLog';
import CallsReducer from './Calls';
import ComsReducer from './Intercom';
import PanelReducer from './Panels';
import VirtualGuardReducer from './VirtualGuard';
import MembersReducer from './Members';
import OtcReducer from './Otc';
import LiveKitReducer from './LiveKit';
import ReservationsReducer from './Reservation';
import DeviceOperationsReducer from './DeviceOperations';
import PlatformMaintenanceReducer from './PlatformMaintenance';
import RentalsReducer from './Rentals';
import IncidentReportsReducer from './IncidentReports';

import { routerReducer } from '../../history';

import { LOGOUT_USER } from '../actions/types';
import NotificationsReducer from './Notifications';

const appReducer = combineReducers({
    router: routerReducer,
    auth: AuthReducer,
    init: InitialReducer,
    modal: ModalReducer,
    menu: MenuReducer,
    snack: SnackbarReducer,
    user: UserReducer,
    manager: ManagerReducer,
    access: AccessLogReducer,
    invites: InvitesReducer,
    org: OrgReducer,
    members: MembersReducer,
    properties: PropertiesReducer,
    reservations: ReservationsReducer,
    rentals: RentalsReducer,
    incidentReports: IncidentReportsReducer,
    calls: CallsReducer,
    coms: ComsReducer,
    panel: PanelReducer,
    vg: VirtualGuardReducer,
    otc: OtcReducer,
    livekit: LiveKitReducer,
    device: DeviceOperationsReducer,
    platformMaintenance: PlatformMaintenanceReducer,
    notifications: NotificationsReducer
});

const rootReducer = (state, action) => {
    if (action.type === LOGOUT_USER) {
        const { init } = state;
        state = { init };
    }
    return appReducer(state, action);
};

export default rootReducer;
